// extracted by mini-css-extract-plugin
export var baseButton = "_vl-0";
export var controlsArrowKeys = "_vl-1";
export var controlsResetButton = "_vl-2";
export var lightGameButton = "_vl-4 _vl-0";
export var playAgainButton = "_vl-5 _vl-0";
export var startGameButton = "_vl-3 _vl-0";